import { render, staticRenderFns } from "./PaymentModel.vue?vue&type=template&id=6c331236&"
import script from "./PaymentModel.vue?vue&type=script&lang=js&"
export * from "./PaymentModel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports